export default __webpack_public_path__ + "static/media/viking helmet.df9af514.png";